import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { AuthenticatedProvider } from './auth/AuthContext';
import AuthLogin from './auth/AuthLogin';
import Dashboard from './components/Dashboard';
import AuthGuard from './utils/route-guard/AuthGuard';
import './App.css';

// Create a Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2'
    },
    secondary: {
      main: '#dc004e'
    }
  },
  typography: {
    fontFamily: 'Poppins, sans-serif'
  }
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3}>
        <AuthenticatedProvider>
          <Router>
            <Box sx={{ minHeight: '100vh' }}>
              <Routes>
                {/* Default Route */}

                {/* Login Route */}
                <Route path="/login" element={<AuthLogin />} />

                {/* Dashboard Route - Protected */}
                <Route
                  path="/dashboard"
                  element={
                    <AuthGuard>
                      <Dashboard />
                    </AuthGuard>
                  }
                />

                {/* Catch-all Route */}
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </Box>
          </Router>
        </AuthenticatedProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
